import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import InputField from "./InputField.tsx";

const Wrapper = styled.div`
  position: relative;
  width: 100%;
`;

const Dropdown = styled.ul`
  position: absolute;
  width: 100%;
  max-height: 150px;
  overflow-y: auto;
  list-style: none;
  padding: 0;
  margin: 0;
  background: white;
  border: 1px solid #ccc;
  border-top: none;
  z-index: 1000;
`;

const DropdownItem = styled.li`
  padding: 8px;
  cursor: pointer;
  &:hover {
    background: #f0f0f0;
  }
`;

export interface InputFieldProps {
  values: { value: string; label: string }[];
  onChange: ({ value, label }: { value: string; label: string }) => void;
  name: string;
  icon?: React.ReactNode;
  placeholder?: string;
  currentValue?: { value: string; label: string };
}

const InputDropdown: React.FC<InputFieldProps> = ({
  values,
  onChange,
  name,
  icon,
  placeholder,
  currentValue,
}) => {
  const [inputValue, setInputValue] = useState(
    currentValue ? currentValue.label : ""
  );
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const filteredValues =
    values && values.length > 0
      ? values.filter((value) =>
          value.label.toLowerCase().includes(inputValue.toLowerCase())
        )
      : [];

  const handleSelect = (value: string, label: string) => {
    setInputValue(label);
    setIsOpen(false);

    onChange({ value, label: label });
  };

  return (
    <Wrapper ref={wrapperRef}>
      <InputField
        name={name}
        type="text"
        value={inputValue}
        onChange={(e) => {
          setInputValue(e.target.value);
          onChange({ label: e.target.value, value: "-1" });
          setIsOpen(true);
        }}
        isRequired
        placeholder={placeholder}
        icon={icon}
      />

      {isOpen && filteredValues && filteredValues.length > 0 && (
        <Dropdown>
          {filteredValues.map(({ value, label }) => (
            <DropdownItem
              key={value}
              onClick={() => handleSelect(value, label)}
            >
              {label}
            </DropdownItem>
          ))}
        </Dropdown>
      )}
    </Wrapper>
  );
};

export default InputDropdown;
